import { offerCodeEnum } from '@@viewEnums';
import { either, equals, includes, isEmpty, isNil, map, path, pathOr, pick, propOr } from 'ramda';

const useExtraSyntheseForm = ({ getMiddleBoolean, projectStatus, form }) => {
  const formValues = form.getValues();
  const signatureAdvice =
    getMiddleBoolean('PROCESSDEVENTE_SIGNATURE_SYNTHESE_ELECTRONIQUE_DISPONIBLE') &&
    !equals(form.watch('collectionNeeds.0.customerAgreement'), true);

  let isDutyOfAdviceSkipped = true;
  const offerCode = path(['offer', 'code'], formValues);
  if (equals(offerCode, offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT)) {
    isDutyOfAdviceSkipped = pathOr(
      false,
      ['collectionNeeds', 0, 'isDutyOfAdviceSkipped'],
      formValues
    );
  } else if (equals(offerCode, offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION)) {
    isDutyOfAdviceSkipped = !either(
      isNil,
      isEmpty
    )(form.watch('collectionNeeds.0.customerAgreement'));
  }

  const isAdviceSignatureSentForSignature = equals(projectStatus, 'ADVICE_SENT_FOR_SIGNATURE');
  const isAdviceSignatureError = includes(projectStatus, [
    'ADVICE_SIGNATURE_REFUSED',
    'ADVICE_SIGNATURE_EXPIRED'
  ]);
  const isAdviceSignatureSigned = includes(projectStatus, ['ADVICE_SIGNED']);

  const data = {
    ...pick(['commission'], formValues),
    collectionNeeds: map(pick(['customerAgreement']), propOr([], 'collectionNeeds', formValues))
  };

  return {
    signatureAdvice,
    isAdviceSignatureSentForSignature,
    isAdviceSignatureError,
    isAdviceSignatureSigned,
    isDutyOfAdviceSkipped,
    data
  };
};

export default useExtraSyntheseForm;
